import { ButtonIcon, FontIcon, Tag, tokens } from '@arvoreeducacao/bonsai-ds'
import React, { useState } from 'react'
import {
  CardContainer,
  InfoContainer,
  UserInfoContainer,
  ContentContainer,
  ContentName,
  CardTitle
} from './CardItemJobPositionsAndRole.styles'
import type { CardItemJobPositionsAndRoleProps } from '../types'
import UpdateJobPositionOrAreaModal from '../update-job-position-or-area-modal'
import { JobOption } from '../update-job-position-or-area-modal/constants'
import { useToggle } from 'usehooks-ts'
import { useTranslation } from 'i18n'

const CardItemJobPositionsAndRole = ({
  info
}: {
  info: CardItemJobPositionsAndRoleProps
}) => {
  const [jobOption, setJobOption] = useState<JobOption>(JobOption.JOB_POSITIONS)
  const [isModalOpen, toggleIsModalOpen] = useToggle()
  const { t } = useTranslation()

  const handleOpenModal = () => {
    toggleIsModalOpen()

    if (info.name === 'Cargos') {
      return setJobOption(JobOption.JOB_POSITIONS)
    }

    setJobOption(JobOption.JOB_AREAS)
  }

  return (
    <CardContainer key={info.name}>
      <InfoContainer>
        <UserInfoContainer>
          <FontIcon
            iconName={info.iconName}
            size={16}
            color={tokens.colors.dark6}
          />
          <CardTitle>{info.name}</CardTitle>
        </UserInfoContainer>
        <ContentContainer>
          {info.content?.length ? (
            <ContentName>{info.content[0].name}</ContentName>
          ) : (
            <ContentName>{`Não possui ${info.name}`}</ContentName>
          )}
          {info.content?.length > 1 && (
            <Tag type="primaryDark">{`+${info.content.length - 1}`}</Tag>
          )}
        </ContentContainer>
      </InfoContainer>
      {info.name !== 'Permissões' && (
        <ButtonIcon
          iconName="edit"
          theme={{
            type: 'secondary',
            size: 'large'
          }}
          onClick={handleOpenModal}
          aria-label={t('Editar')}
        />
      )}

      <UpdateJobPositionOrAreaModal
        jobOption={jobOption}
        isOpen={isModalOpen}
        onClose={toggleIsModalOpen}
      />
    </CardContainer>
  )
}

export default CardItemJobPositionsAndRole
